import { render, staticRenderFns } from "./PieDemo.vue?vue&type=template&id=f6c61784&scoped=true"
import script from "./PieDemo.vue?vue&type=script&lang=js"
export * from "./PieDemo.vue?vue&type=script&lang=js"
import style0 from "./PieDemo.vue?vue&type=style&index=0&id=f6c61784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c61784",
  null
  
)

export default component.exports